const typewriteWords = document.querySelector('.theme-featured-collection--wrapper h2.featured-collection-v2-title')?.dataset.typewriterWords
const words = typewriteWords.split('|')

let wordIndex = 0;
let charIndex = 0;
let currentWord = words[wordIndex];
let isDeleting = false;

function type() {
  const typewriterElement = document.getElementById("typewriter");

  if (!isDeleting && charIndex < currentWord.length) {
    // Typing forward
    typewriterElement.textContent += currentWord.charAt(charIndex);
    charIndex++;
    setTimeout(type, 100);
  } else if (isDeleting && charIndex > 0) {
    // Deleting the text
    typewriterElement.textContent = currentWord.substring(0, charIndex - 1);
    charIndex--;
    setTimeout(type, 50);
  } else if (!isDeleting && charIndex === currentWord.length) {
    // Wait after typing complete
    setTimeout(() => {
      isDeleting = true;
      setTimeout(type, 100);
    }, 1500);
  } else if (isDeleting && charIndex === 0) {
    // Move to next word
    isDeleting = false;
    wordIndex = (wordIndex + 1) % words.length;
    currentWord = words[wordIndex];
    setTimeout(type, 500);
  }
}

// Start the typing effect
type();
